import { render, staticRenderFns } from "./SCIPNotificationPreview.vue?vue&type=template&id=00ca58b3&"
import script from "./SCIPNotificationPreview.vue?vue&type=script&lang=js&"
export * from "./SCIPNotificationPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports